// `cta` is the action verb shown on the attendance button and login-gate, so the
// copy fits the event type — you "RSVP" to a potluck but "Register" for VBS, "Sign up"
// to serve, "Join" a study/group. Keep it a short verb phrase (no "— I'm going" flair).
export const EVENT_TYPES = {
  potluck: {
    name: 'Potluck',
    color: '#D97F4A',
    tint: '#FBEFE6',
    sub: 'Dish coordination',
    cta: 'RSVP',
  },
  worship: {
    name: 'Worship',
    color: '#4A7EC4',
    tint: '#E3EAF8',
    sub: 'Prayer · concert',
    cta: 'RSVP',
  },
  study: {
    name: 'Bible Study',
    color: '#C29A3D',
    tint: '#F7F0DC',
    sub: 'Topic · scripture',
    cta: 'Join',
  },
  social: {
    name: 'Social',
    color: '#C75D8A',
    tint: '#F8E6EE',
    sub: 'Casual gathering',
    cta: 'RSVP',
  },
  outdoors: {
    name: 'Outdoors',
    color: '#5B8B6B',
    tint: '#E8F0EA',
    sub: 'Hike · sport · trail',
    cta: 'RSVP',
  },
  groups: {
    name: 'Groups',
    color: '#3B9E8C',
    tint: '#E2F3F0',
    sub: 'Small group · life group',
    cta: 'Join',
  },
  kids: {
    name: 'Kids & Youth',
    color: '#D4A843',
    tint: '#F8F1DC',
    sub: 'VBS · camp · youth',
    cta: 'Register',
  },
  service: {
    name: 'Service',
    color: '#7C5CD3',
    tint: '#EFEAF8',
    sub: 'Volunteer outreach',
    cta: 'Sign up',
  },
} as const

// EventType is defined in types/index.ts — import from there
export function getEventType(key: string) {
  return EVENT_TYPES[key as keyof typeof EVENT_TYPES] ?? EVENT_TYPES.potluck
}

// The action verb for an event type's attendance CTA (e.g. "RSVP", "Register").
// Falls back to "RSVP" for unknown types.
export function getEventCta(key: string): string {
  return getEventType(key).cta
}
